import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import rules from '@/app/shared/domain/data/rules';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputAddress',
  props: ['modelValue'],
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;




function updateModel(value: any, field: string) {
    emit('update:modelValue', {
        ...props.modelValue,
        [field]: value
    });
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        md: "3"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_v_text_field, {
            "model-value": __props.modelValue?.zip_code,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (updateModel($event, 'zip_code'))),
            label: "CEP",
            rules: [_unref(rules).cep]
          }, null, 8, ["model-value", "rules"]), [
            [_directive_mask, '##.###-###']
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "7"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            "model-value": __props.modelValue?.street,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (updateModel($event, 'street'))),
            label: "Logradouro"
          }, null, 8, ["model-value"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "6",
        md: "2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            "model-value": __props.modelValue?.number,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (updateModel($event, 'number'))),
            label: "Número"
          }, null, 8, ["model-value"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "6",
        md: "3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            "model-value": __props.modelValue?.complement,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (updateModel($event, 'complement'))),
            label: "Complemento"
          }, null, 8, ["model-value"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "6",
        md: "3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            "model-value": __props.modelValue?.neighborhood,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (updateModel($event, 'neighborhood'))),
            label: "Bairro"
          }, null, 8, ["model-value"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "6",
        md: "4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            "model-value": __props.modelValue?.city,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (updateModel($event, 'city'))),
            label: "Município"
          }, null, 8, ["model-value"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "3",
        md: "2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            "model-value": __props.modelValue?.state,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (updateModel($event, 'state'))),
            label: "Uf"
          }, null, 8, ["model-value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})